import * as React from "react";
import { Modal, Header, Button } from "semantic-ui-react";

export type ConfirmationModalProps = {
  /** `true` if the dialog is open */
  isOpen: boolean;
  /** Modal size */
  size: "fullscreen" | "large" | "mini" | "small" | "tiny";
  /** Header text */
  header: string;
  /** Body text or element */
  content: string | JSX.Element;
  /** Note text or element */
  note?: string;
  /** (optional) Text shown in the confirm button when no children is passed */
  confirmText?: string;
  /** (optional) Text shown in the cancel button when no children is passed */
  cancelText?: string;
  /** (optional) Disable confirm button when no children is passed */
  isConfirmDisabled?: boolean;
  /** (optional) Handles confirm callback when no children is passed */
  onConfirm?: () => void;
  /** (optional) Handles cancel callback when no children is passed */
  onCancel?: () => void;
  /** (optional) children containing modal actions */
  children?: JSX.Element;
};

/** Custom modal component. `Modal.Actions` can be passed as children */
const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  size,
  header,
  content,
  note,
  confirmText,
  cancelText,
  isConfirmDisabled,
  onConfirm,
  onCancel,
  children
}) => (
  <Modal open={isOpen} size={size}>
    <Header>{header}</Header>
    <Modal.Content>
      {typeof content === "string" ? (
        <>
          <p>{content}</p>
        </>
      ) : (
        content
      )}
      {note && (
        <p>
          <b>{note}</b>
        </p>
      )}
    </Modal.Content>
    {children || (
      <Modal.Actions>
        <Button onClick={onCancel}>{cancelText}</Button>
        <Button color="red" disabled={isConfirmDisabled} onClick={onConfirm}>
          {confirmText}
        </Button>
      </Modal.Actions>
    )}
  </Modal>
);

export default ConfirmationModal;

